'use strict';

require('./cell-extensions');

require('./column-extensions');

require('./row-extensions');

require('./table-extensions');


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/api/index.js
// module id = 1107
// module chunks = 1